/**
 * The cropped image out of `ImageCropperModal`, whatever shape it dismissed with.
 *
 * The modal dismisses `{ blob, zoom, transform, cropWidth, cropHeight, cropX, cropY }`
 * — the extra fields exist so a caller can re-crop later from the original. Callers
 * that only want the image were still typed as receiving a bare `Blob`, so they
 * passed the whole object to `FormData.append()` and got "parameter 2 is not of type
 * 'Blob'" at runtime.
 *
 * Accepts either shape so it stays correct whichever the modal returns.
 */
export function croppedBlobOf(result: unknown): Blob | null {
    if (result instanceof Blob) {
        return result;
    }
    const blob = (result as { blob?: unknown } | null)?.blob;
    return blob instanceof Blob ? blob : null;
}
